import { BASE_TITLE, issuerMapping } from 'constants/common';
import { Helmet } from 'react-helmet';

interface IProps {
  issuer: string;
  page?: string;
}

const PageSettings = ({ issuer, page }: IProps) => {
  const title = issuerMapping(issuer, page);

  return (
    <Helmet>
      <title>
        {BASE_TITLE}
        {title ? ` - ${title}` : ''}
      </title>
    </Helmet>
  );
};

export default PageSettings;
